// extracted by mini-css-extract-plugin
module.exports = {"root":"MenuSidebarView_root__QjWQB","item":"MenuSidebarView_item__Y2hvw"};